const navContent = [
  { label: "实验简介", link: "index" },
  { label: "学习流程", link: "learn" },
  { label: "构件认知", link: "info" },
  { label: "实景学习", link: "realitylearn" },
  { label: "虚拟搭建", link: "virtuallearn" }
];

let legalNavLink = [];
navContent.forEach(({ link }) => {
  legalNavLink.push(link);
});

export { navContent, legalNavLink };
